import {Field, FileUpload, Input, Label, Message} from "@zendeskgarden/react-forms";
import {Button} from "@zendeskgarden/react-buttons";
import React, {ReactElement, useRef} from "react";

export interface IFileUploadFieldProps {
    value: File | undefined;
    onChange: (value: File | undefined) => void;
    label: string;
    message?: string;
}

export function FileUploadField(props: IFileUploadFieldProps): ReactElement {
    const fileInputRef = useRef<HTMLInputElement | null>(null);

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            props.onChange(event.target.files[0]);
        }
    };

    const renderSize = (size: number): string => {
        let i = 0;
        while(size > 1024 && i < 3) {
            size /= 1024;
            i++;
        }

        if(i === 0) {
            return `${size} bytes`;
        } else if(i === 1) {
            return `${size.toFixed(2)} KB`;
        } else {
            return `${size.toFixed(2)} MB`;
        }
    };

    return <Field>
        <Label>{props.label}</Label>
        <FileUpload
                style={{display: !props.value ? "block" : "none"}}
                role="button"
                onClick={() => {
                    if(fileInputRef) {
                        fileInputRef.current?.click();
                    }
                }}
        >
            {props.message && <Message>{props.message}</Message>}
            <Input ref={fileInputRef} style={{display:"none"}} type="file" accept=".png,.jpg,.jpeg" onChange={handleFileChange} />
        </FileUpload>
        {props.value &&
            <div style={{fontSize: "0.9rem", textAlign: "center"}}>
                {props.value.name} ({renderSize(props.value.size)})
                <Button isBasic onClick={() => {
                    props.onChange(undefined);
                    if(fileInputRef.current) {
                        const input = fileInputRef.current;
                        if(input.files && input.files.length > 0) {
                            input.value = "";
                        }
                    }
                }}>Remove</Button>
            </div>
        }
    </Field>;
}